import { render, staticRenderFns } from "./NotesTab.vue?vue&type=template&id=2eb55b22"
import script from "./NotesTab.vue?vue&type=script&lang=js"
export * from "./NotesTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports